angular.module('siter.io').controller 'PreviewCtrl', ["$scope", "$rootScope", "Auth", "$state", "User", "$filter", "$sce", "Lesson", ($scope, $rootScope, Auth, $state, User, $filter, $sce, Lesson) ->

  $rootScope.openPreview = (jcSiteId) ->
    angular.element('body').addClass 'modal-open'
    frameUrl = "/sites/constructor/preview/jc_site_id/#{jcSiteId}/fromConstructor/true"

    previewParts = getPreviewParts()

    $scope.preview = {
      active: true,
      siteName: $rootScope.site.name,
      frameUrl: frameUrl,
      header: previewParts.header,
      footer: previewParts.footer
    }

  $scope.closePreview = ->
    angular.element('body').removeClass 'modal-open'
    $scope.preview.active = false

  $scope.renderHtml = (html) ->
    return $sce.trustAsHtml(html);

  $scope.initContainer = ->
    if isLmsPreview()
      $contentContainer = $(".preview__content")
      $contentContainer.css $rootScope.currentPage.style_attributes
      $contentContainer.find('.preview__frame').addClass('e__lesson__frame')

      isImageExist = $rootScope.currentPage.background_attributes and $rootScope.currentPage.background_attributes.image_attributes and $rootScope.currentPage.background_attributes.image_attributes.source_url
      if isImageExist
        $contentContainer.css {backgroundImage: "url('#{$rootScope.currentPage.background_attributes.image_attributes.source_url}')"}

      if $rootScope.currentPage.background_attributes and $rootScope.currentPage.background_attributes.gradient
        setGradient $rootScope.currentPage.background_attributes

      return true

  setGradient = (background_attributes) ->
    color_start = background_attributes.color_start
    color_stop = background_attributes.color_stop
    gradient_css = "
      background-image:-moz-linear-gradient(top, #{color_start}, #{color_stop});
      background-image:-webkit-linear-gradient(top, #{color_start}, #{color_stop});
      background-image:-o-linear-gradient(top, #{color_start}, #{color_stop});
      background-image:-ms-linear-gradient(top, #{color_start}, #{color_stop});,
      background-image:linear-gradient(top, #{color_start}, #{color_stop});
      filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='#{color_start}', endColorstr='#{color_stop}');"

    if $("style##{$rootScope.currentPage.id}_preview").length > 0
      $("style##{$rootScope.currentPage.id}_preview").html ".preview__content.e__lesson:before { #{gradient_css} }"
    else
      $('body').append("<style id='#{$rootScope.currentPage.id}_preview'>.preview__content.e__lesson:before { #{gradient_css} }</style>");

  getPreviewParts = ->
    parts = {
      header: '',
      footer: '',
    }

    if isLmsPreview()
      parts.header = window.justclick.lms.header
      parts.footer = window.justclick.lms.footer

      Lesson.getLmsStylesheets().then (response) ->
        angular.element('#preview_custom_styles').html response

    return parts

  isLmsPreview = ->
    return Editor.mode == 'lesson.page.editor' and !!window.justclick.lms

  window.iFrameUploadDone = (iFrameNode) ->
    iFrameDocument = iFrameNode.contentWindow.document;

    iFrameNode.style.height = iFrameDocument.body.scrollHeight + 'px';

    if isLmsPreview()
      $iFrameDocument = $(iFrameDocument);
      $parentDocument = $(parent.document);

      customStyleNodes = $parentDocument.find('#preview_custom_styles').children()
      _.each customStyleNodes, (styleNode) ->
        $(styleNode).clone().appendTo($iFrameDocument.find('head'))
        $iFrameDocument.find('body').addClass('e__lesson')
]



// WEBPACK FOOTER //
// ./src/app/common/controllers/preview.controller.coffee